module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-customserver",
    class: [_vm.is_connecting ? 'kiwi-customserver--connecting' : '']
  }, [(!_vm.is_connecting) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _c('h2', [_vm._v(_vm._s(_vm.$t('connecting')) + " "), _c('a', {
    staticClass: "u-link",
    on: {
      "click": _vm.infoClick
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "connectingloader"
    }
  }, [(!_vm.is_connecting) ? _c('form', {
    staticClass: "u-form kiwi-customserver-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.startUp($event)
      }
    }
  }, [(_vm.network && _vm.network.state_error) ? _c('div', {
    staticClass: "kiwi-customserver-error"
  }, [_vm._v("We couldn't connect to the server :( "), _c('span', [_vm._v(_vm._s(_vm.readableStateError(_vm.network.state_error)))])]) : _vm._e(), _vm._v(" "), (_vm.server_type === 'default') ? [_c('input-text', {
    attrs: {
      "label": _vm.$t('server')
    },
    model: {
      value: (_vm.server),
      callback: function($$v) {
        _vm.server = $$v
      },
      expression: "server"
    }
  }, [_c('span', {
    staticClass: "fa-stack fa-lg kiwi-customserver-tls",
    class: [_vm.tls ? 'kiwi-customserver-tls--enabled' : ''],
    on: {
      "click": function($event) {
        _vm.tls = !_vm.tls
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lock fa-stack-1x kiwi-customserver-tls-lock"
  }), _vm._v(" "), (!_vm.tls) ? _c('i', {
    staticClass: "fa fa-times fa-stack-1x kiwi-customserver-tls-minus"
  }) : _vm._e()])]), _vm._v(" "), _c('input-text', {
    staticClass: "kiwi-customserver-nick",
    attrs: {
      "label": _vm.$t('nick')
    },
    model: {
      value: (_vm.nick),
      callback: function($$v) {
        _vm.nick = $$v
      },
      expression: "nick"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "kiwi-customserver-have-password"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show_password_box),
      expression: "show_password_box"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.show_password_box) ? _vm._i(_vm.show_password_box, null) > -1 : (_vm.show_password_box)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.show_password_box,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.show_password_box = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.show_password_box = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.show_password_box = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('password_have')) + "\n            ")]), _vm._v(" "), (_vm.show_password_box) ? _c('input-text', {
    attrs: {
      "label": _vm.$t('password'),
      "type": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }) : _vm._e(), _vm._v(" "), _c('input-text', {
    attrs: {
      "label": _vm.$t('channel')
    },
    model: {
      value: (_vm.channel),
      callback: function($$v) {
        _vm.channel = $$v
      },
      expression: "channel"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.server_type === 'default_simple') ? [_c('input-text', {
    staticClass: "kiwi-customserver-nick",
    attrs: {
      "label": _vm.$t('nick')
    },
    model: {
      value: (_vm.nick),
      callback: function($$v) {
        _vm.nick = $$v
      },
      expression: "nick"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "kiwi-customserver-have-password"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show_password_box),
      expression: "show_password_box"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.show_password_box) ? _vm._i(_vm.show_password_box, null) > -1 : (_vm.show_password_box)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.show_password_box,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.show_password_box = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.show_password_box = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.show_password_box = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('password_have')) + "\n            ")]), _vm._v(" "), (_vm.show_password_box) ? _c('input-text', {
    attrs: {
      "label": _vm.$t('password'),
      "type": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }) : _vm._e(), _vm._v(" "), _c('input-text', {
    staticClass: "kiwi-customserver-channel",
    attrs: {
      "label": _vm.$t('channel')
    },
    model: {
      value: (_vm.channel),
      callback: function($$v) {
        _vm.channel = $$v
      },
      expression: "channel"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.server_type === 'znc') ? [_c('input-text', {
    attrs: {
      "label": _vm.$t('server')
    },
    model: {
      value: (_vm.server),
      callback: function($$v) {
        _vm.server = $$v
      },
      expression: "server"
    }
  }, [_c('span', {
    staticClass: "fa-stack fa-lg kiwi-customserver-tls",
    class: [_vm.tls ? 'kiwi-customserver-tls--enabled' : ''],
    on: {
      "click": function($event) {
        _vm.tls = !_vm.tls
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lock fa-stack-1x kiwi-customserver-tls-lock"
  }), _vm._v(" "), (!_vm.tls) ? _c('i', {
    staticClass: "fa fa-times fa-stack-1x kiwi-customserver-tls-minus"
  }) : _vm._e()])]), _vm._v(" "), _c('input-text', {
    staticClass: "kiwi-customserver-nick",
    attrs: {
      "label": _vm.$t('username')
    },
    model: {
      value: (_vm.nick),
      callback: function($$v) {
        _vm.nick = $$v
      },
      expression: "nick"
    }
  }), _vm._v(" "), (_vm.znc_network_support) ? _c('input-text', {
    attrs: {
      "label": _vm.$t('network')
    },
    model: {
      value: (_vm.znc_network),
      callback: function($$v) {
        _vm.znc_network = $$v
      },
      expression: "znc_network"
    }
  }) : _vm._e(), _vm._v(" "), _c('input-text', {
    attrs: {
      "label": _vm.$t('password'),
      "type": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })] : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "u-button u-button-primary u-submit",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.buttonText))]), _vm._v(" "), (_vm.show_type_switcher) ? _c('div', {
    staticClass: "kiwi-customserver-server-types"
  }, [_c('a', {
    staticClass: "u-link",
    on: {
      "click": function($event) {
        _vm.server_type = 'default'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('network')))]), _vm._v(" "), _c('a', {
    staticClass: "u-link",
    on: {
      "click": function($event) {
        _vm.server_type = 'znc'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('znc')))])]) : _vm._e()], 2) : _c('div', {
    staticClass: "kiwi-customserver-loader"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-022a5f1c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/startups/CustomServer.vue
// module id = 473
// module chunks = 2